/**
 * rb-diamond.js — Ring Builder: Selección de Diamante
 * Lee configuración de window.rbDiamondConfig (inyectado por Liquid).
 *
 * Flujo:
 *   - Si viene con ?setting=ID → mostrar sticky bar de montura seleccionada
 *   - Al seleccionar diamante: llama CF Worker /diamonds/select,
 *     guarda en sessionStorage y navega a setting page (o review si setting ya elegido)
 */

(function () {
  'use strict';

  var cfg = window.rbDiamondConfig || {};
  var cfWorkerUrl = cfg.cfWorkerUrl || window.cfWorkerUrl || 'https://diamore-proxy.diamorejoyeros.workers.dev';

  // Validate that entrySettingVariantId is a numeric string (real variant ID)
  var entrySettingId = (/^\d+$/.test(cfg.entrySettingVariantId || ''))
    ? cfg.entrySettingVariantId : '';

  var entryShape     = (cfg.entryShape     || '').toUpperCase();
  var entryStoneType = cfg.entryStoneType || '';

  // Prefiltrado: leer sessionStorage.diamore_setting si no vienen datos en la URL
  if (!entryShape || !entryStoneType) {
    var _storedSetting = null;
    try { _storedSetting = JSON.parse(sessionStorage.getItem('diamore_setting') || 'null'); } catch (e) {}
    if (_storedSetting) {
      if (!entryShape && _storedSetting.shape) {
        entryShape = String(_storedSetting.shape).toUpperCase();
      }
      if (!entryStoneType) {
        if (_storedSetting.labgrown === true ||
            (_storedSetting.title && /lab/i.test(_storedSetting.title))) {
          entryStoneType = 'lab';
        }
      }
    }
  }

  var filters = {
    shapes:    entryShape ? [entryShape] : [],
    carat_min: 1,
    carat_max: 5.00,
    color:     ["D","E","F"],
    clarity:   ["FL","IF","VVS1","VVS2","VS1"],
    cert:      [],
    cuts:      ["VERY_GOOD","EXCELLENT","IDEAL"],
    price_min: 0,
    price_max: 50000,
    sort:      'price_asc',
    offset:    0,
    per_page:  50
  };

  var DISPLAY_PER_PAGE = 12;

  var _rawStoneType = entryStoneType || sessionStorage.getItem('diamore_stone_type');
  var stoneType = (_rawStoneType && _rawStoneType !== 'null') ? _rawStoneType : 'lab';
  // Default siempre lab cuando no hay valor válido
  if (!_rawStoneType || _rawStoneType === 'null') {
    sessionStorage.setItem('diamore_stone_type', 'lab');
  }
  var isLoading        = false;
  var appendMode       = false;
  var allLoadedResults = [];   // buffer acumulado (48 por ronda)
  var displayedCount   = 0;   // cuántos se muestran actualmente
  var results          = [];  // alias — apunta siempre al slice visible
  var totalCount       = 0;
  var rbHasNextPage    = false;
  var debTimer         = null;
  var _bindsDone       = false;

  // ── Init ────────────────────────────────────────────────────────────────────

  function init() {
    sessionStorage.setItem('diamore_stone_type', stoneType);

    // Sync stone type radio
    var radio = document.querySelector('input[name="rb-stone-type"][value="' + stoneType + '"]');
    if (radio) radio.checked = true;

    // Sync stone toggle buttons
    document.querySelectorAll('.rb-stone-toggle__opt').forEach(function (btn) {
      btn.classList.toggle('rb-stone-toggle__opt--active', btn.dataset.type === stoneType);
    });

    // Activate entry shape pill + lock other shapes when coming from a setting
    if (entryShape) {
      // Desktop shapes
      document.querySelectorAll('#rb-filter-shapes [data-shape]').forEach(function (btn) {
        if (btn.dataset.shape.toUpperCase() === entryShape) {
          btn.classList.add('rb-filter-btn--active');
          btn.setAttribute('aria-pressed', 'true');
        } else {
          btn.classList.add('rb-shape-locked');
          btn.setAttribute('aria-disabled', 'true');
        }
      });
      // Mobile shapes
      document.querySelectorAll('.rb-shape-btn-mobile[data-shape-mobile]').forEach(function (btn) {
        if (btn.dataset.shapeMobile.toUpperCase() === entryShape) {
          btn.classList.add('rb-filter-btn--active');
          btn.setAttribute('aria-pressed', 'true');
        } else {
          btn.classList.add('rb-shape-locked');
          btn.setAttribute('aria-disabled', 'true');
        }
      });
      // Show locked message
      var lockedMsg = document.querySelector('.rb-shape-locked-msg');
      if (lockedMsg) lockedMsg.classList.add('visible');
    }

    // If came from setting page: show context bar and update back link
    if (entrySettingId) {
      var settingData = null;
      try { settingData = JSON.parse(sessionStorage.getItem('diamore_setting') || 'null'); } catch (e) {}

      var contextBar = document.getElementById('rb-setting-context');
      if (contextBar) {
        contextBar.classList.remove('rb-hidden');
        var infoEl = document.getElementById('rb-context-setting-info');
        if (infoEl && settingData && settingData.name) {
          infoEl.textContent = settingData.name;
        }
      }

      var backLink = document.getElementById('rb-back-link');
      if (backLink) backLink.href = '/collections/monturas';
    }

    // Marcar colores activos según tipo (Lab: D-F, Natural: D-J)
    applyDefaultColors(stoneType);

    // Marcar claridades activas visualmente
    ["FL","IF","VVS1","VVS2","VS1"].forEach(function(c) {
      var btn = document.querySelector('[data-clarity="'+c+'"]');
      if (btn) { btn.classList.add('rb-filter-btn--active'); btn.setAttribute('aria-pressed','true'); }
    });

    var loadMoreBtn = document.getElementById('rb-load-more');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        if (displayedCount < allLoadedResults.length) {
          // Mostrar los próximos 12 del buffer local
          displayedCount = Math.min(displayedCount + DISPLAY_PER_PAGE, allLoadedResults.length);
          results = allLoadedResults.slice(0, displayedCount);
          renderGrid();
          renderPagination();
          updateCount();
        } else if (rbHasNextPage) {
          // Pedir los siguientes 48 a Nivoda (offset +50)
          filters.offset += 50;
          appendMode = true;
          fetchDiamonds();
        }
      });
    }

    bindEvents();
    syncMobileFilters();
    fetchDiamonds();
  }

  // ── Helpers ─────────────────────────────────────────────────────────────────

  function applyDefaultColors(tipo) {
    var labColors     = ['D', 'E', 'F'];
    var naturalColors = ['D', 'E', 'F', 'G', 'H', 'I', 'J'];
    var defaults = tipo === 'natural' ? naturalColors : labColors;
    filters.color = defaults.slice();
    document.querySelectorAll('#rb-filter-colors [data-color]').forEach(function (btn) {
      var c = btn.dataset.color;
      if (defaults.indexOf(c) > -1) {
        btn.classList.add('rb-filter-btn--active');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.classList.remove('rb-filter-btn--active');
        btn.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function isLabGrown(diamond) {
    var cert = diamond.certificate || diamond;

    // 1. Campo explícito de Nivoda
    if (cert.labgrown === true) return true;
    if (cert.labgrown === false) return false;

    // 2. lab_type del resultado procesado por el CF Worker
    if (diamond.lab_type === 'lab') return true;
    if (diamond.lab_type === 'natural') return false;

    // 3. Prefijo del número de certificado IGI (certNumber o cert_number)
    var certNum = cert.certNumber || cert.cert_number || '';
    if (certNum && certNum.toString().startsWith('LG')) return true;

    // 4. Fallback al campo del objeto padre
    if (diamond.labgrown === true) return true;

    return false;
  }

  function fmt$(n) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: 'USD',
      minimumFractionDigits: 0, maximumFractionDigits: 0
    }).format(n || 0) + ' USD';
  }

  function esc(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function escAttr(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/'/g, '&#39;').replace(/"/g, '&quot;');
  }

  function showError(msg) {
    var el = document.getElementById('rb-global-error');
    if (!el) return;
    el.textContent = msg;
    el.classList.remove('rb-hidden');
    setTimeout(function () { el.classList.add('rb-hidden'); }, 6000);
  }

  function debounce(fn, delay) {
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(debTimer);
      debTimer = setTimeout(function () { fn.apply(ctx, args); }, delay);
    };
  }

  function diamondSvg() {
    return '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" aria-hidden="true">'
      + '<polygon points="30,5 55,22 45,55 15,55 5,22" stroke="currentColor" stroke-width="1.5" fill="none" opacity="0.4"/>'
      + '<polygon points="30,5 55,22 30,18 5,22" stroke="currentColor" stroke-width="1.5" fill="none" opacity="0.3"/>'
      + '</svg>';
  }

  function skeletons(n) {
    var html = '';
    for (var i = 0; i < n; i++) {
      html += '<div class="rb-card rb-diamond-card rb-skeleton" aria-hidden="true">'
        + '<div class="rb-skeleton__image"></div>'
        + '<div class="rb-card__body">'
        + '<div class="rb-skeleton__line"></div>'
        + '<div class="rb-skeleton__line rb-skeleton__line--short"></div>'
        + '<div class="rb-skeleton__line rb-skeleton__line--price"></div>'
        + '</div></div>';
    }
    return html;
  }

  function updateCaratDisplay() {
    var el = document.getElementById('rb-carat-display');
    if (el) el.textContent = filters.carat_min + ' – ' + filters.carat_max + ' ct';
  }

  function updatePriceTrack() {
    var minSlider = document.getElementById('rb-price-min-mobile');
    var maxSlider = document.getElementById('rb-price-max-mobile');
    if (!minSlider || !maxSlider) return;
    var min   = parseInt(minSlider.value, 10);
    var max   = parseInt(maxSlider.value, 10);
    var total = parseInt(minSlider.getAttribute('max'), 10);
    var minPct = (min / total * 100).toFixed(1);
    var maxPct = (max / total * 100).toFixed(1);
    var gradient = 'linear-gradient(to right, ' +
      '#E6D4C7 0%, ' +
      '#E6D4C7 ' + minPct + '%, ' +
      '#58111A ' + minPct + '%, ' +
      '#58111A ' + maxPct + '%, ' +
      '#E6D4C7 ' + maxPct + '%, ' +
      '#E6D4C7 100%)';
    var parent = minSlider.parentElement;
    parent.style.background = gradient;
    parent.style.backgroundRepeat = 'no-repeat';
  }

  function updateMobilePriceDisplay() {
    var minDisplay = document.getElementById('rb-price-min-display');
    var maxDisplay = document.getElementById('rb-price-max-display');
    if (minDisplay) minDisplay.textContent = filters.price_min.toLocaleString('en-US');
    if (maxDisplay) maxDisplay.textContent = filters.price_max.toLocaleString('en-US');
    var minSlider = document.getElementById('rb-price-min-mobile');
    var maxSlider = document.getElementById('rb-price-max-mobile');
    if (minSlider) minSlider.value = filters.price_min;
    if (maxSlider) maxSlider.value = filters.price_max;
    updatePriceTrack();
  }

  function syncMobileFilters() {
    // Sync stone toggle buttons
    document.querySelectorAll('.rb-stone-toggle__opt').forEach(function (btn) {
      btn.classList.toggle('rb-stone-toggle__opt--active', btn.dataset.type === stoneType);
    });

    // Sync mobile shape buttons
    document.querySelectorAll('.rb-shape-btn-mobile[data-shape-mobile]').forEach(function (btn) {
      var shape = btn.dataset.shapeMobile;
      var isActive = filters.shapes.indexOf(shape.toUpperCase()) > -1;
      btn.classList.toggle('rb-filter-btn--active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      // Lock if shape is locked by entry
      if (entryShape && shape.toUpperCase() !== entryShape) {
        btn.classList.add('rb-shape-locked');
        btn.setAttribute('aria-disabled', 'true');
      }
    });

    updateMobilePriceDisplay();
  }

  // ── Fetch helpers ────────────────────────────────────────────────────────────

  function getActiveShapes() {
    return filters.shapes.length > 0 ? filters.shapes : [];
  }

  function getActiveStoneType() {
    return stoneType || null; // null = ambos (no enviar campo)
  }

  function getActiveColors() {
    return filters.color.length > 0 ? filters.color : null;
  }

  function getActiveClarities() {
    return filters.clarity.length > 0 ? filters.clarity : null;
  }

  function getActiveCertificates() {
    return filters.cert.length > 0 ? filters.cert : null;
  }

  // ── Fetch ────────────────────────────────────────────────────────────────────

  function buildPayload() {
    var activeShapes = getActiveShapes();
    var activeStoneType = getActiveStoneType();

    var priceMin = typeof filters.price_min === 'number' ? filters.price_min :
      (parseInt((document.getElementById('rb-filter-price-min') || {}).value
                || (document.getElementById('rb-price-min-mobile') || {}).value
                || '0', 10) || 0);
    var priceMax = filters.price_max
      || parseInt((document.getElementById('rb-filter-price-max') || {}).value
                  || (document.getElementById('rb-price-max-mobile') || {}).value
                  || '50000', 10)
      || 50000;

    var payload = {
      // Quilates: 1.00 a 5.00
      carat_min: parseFloat(
        (document.getElementById('rb-filter-carat-min') || {}).value || filters.carat_min || 1.0
      ),
      carat_max: parseFloat(
        (document.getElementById('rb-filter-carat-max') || {}).value || filters.carat_max || 5.0
      ),

      // Color D–M (default: todos)
      colors: getActiveColors() || ['D','E','F','G','H','I','J','K','L','M'],

      // Claridad FL–SI2 (default: todas)
      clarities: getActiveClarities() ||
        ['FL','IF','VVS1','VVS2','VS1','VS2','SI1','SI2'],

      // Certificados (default: GIA e IGI)
      certificates: getActiveCertificates() || ['GIA','IGI'],

      // Corte: solo VG/EX/IDEAL
      cuts: filters.cuts && filters.cuts.length > 0 ? filters.cuts : ['VERY_GOOD','EXCELLENT','IDEAL'],

      // Solo diamantes con foto (video es opcional — se muestra badge si existe)
      has_image: true,

      // Precio
      price_min: priceMin,
      price_max: priceMax,

      // Paginación
      offset:   filters.offset,
      per_page: filters.per_page || 24,

      // Orden
      sort: filters.sort || 'price_asc'
    };

    // Forma: solo agregar si hay filtro activo
    // Si no → los 8 cortes: ROUND, OVAL, PRINCESS, PEAR, CUSHION, EMERALD, MARQUISE, RADIANT
    if (activeShapes.length > 0) {
      payload.shapes = activeShapes;
    }

    // Tipo de piedra: solo enviar si hay selección explícita
    // null = ambos (no enviar el campo)
    if (activeStoneType === 'lab') {
      payload.stone_type = 'lab';
    } else if (activeStoneType === 'natural') {
      payload.stone_type = 'natural';
    }

    console.log('getActiveStoneType():', activeStoneType);
    console.log('Payload stone_type:', payload.stone_type);
    console.log('Payload:', JSON.stringify(payload));
    return payload;
  }

  function fetchDiamonds() {
    if (isLoading) return;

    console.log('CF URL:', cfWorkerUrl);
    console.log('Payload:', JSON.stringify(buildPayload()));

    if (!cfWorkerUrl) {
      showError('CF Worker URL no configurada');
      var g = document.getElementById('rb-diamond-grid');
      if (g) g.innerHTML = '<div class="rb-error" role="alert"><p>Error de configuración: CF Worker URL no definida. Contacta al administrador.</p></div>';
      return;
    }

    isLoading = true;
    var grid = document.getElementById('rb-diamond-grid');
    if (!grid) { isLoading = false; return; }

    if (!appendMode) {
      grid.innerHTML = skeletons(6);
    } else {
      var spinner = document.createElement('div');
      spinner.id = 'rb-load-more-spinner';
      spinner.className = 'rb-load-more-spinner';
      spinner.innerHTML = '<div class="rb-spinner rb-spinner--sm"></div>';
      var wrap = document.getElementById('rb-load-more-wrap');
      if (wrap) wrap.classList.remove('visible');
      grid.appendChild(spinner);
    }

    var payload = buildPayload();

    fetch(cfWorkerUrl + '/diamonds/search', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(payload)
    })
      .then(function (res) {
        console.log('Response status:', res.status);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        console.log('Response data:', data);
        var newItems = data.diamonds || data.results || [];
        rbHasNextPage = data.hasNextPage === true;
        if (data.totalCount) totalCount = data.totalCount;

        if (appendMode) {
          allLoadedResults = allLoadedResults.concat(newItems);
        } else {
          allLoadedResults = newItems;
          displayedCount   = 0;
        }
        appendMode = false;
        isLoading  = false;

        // Mostrar los primeros 12 del buffer (o continuar desde donde estaba en append)
        displayedCount = Math.min(displayedCount + DISPLAY_PER_PAGE, allLoadedResults.length);
        results        = allLoadedResults.slice(0, displayedCount);
        if (!data.totalCount) totalCount = allLoadedResults.length;

        renderGrid();
        renderPagination();
        updateCount();
      })
      .catch(function (err) {
        console.error('Error completo:', err.message, err.stack);
        appendMode = false;
        isLoading  = false;
        grid.innerHTML = '<div class="rb-error" role="alert">'
          + '<p>Error cargando diamantes. Por favor intenta de nuevo.</p>'
          + '<button class="rb-btn rb-btn--outline" id="rb-retry-btn">Reintentar</button>'
          + '</div>';
        var btn = document.getElementById('rb-retry-btn');
        if (btn) btn.addEventListener('click', fetchDiamonds);
      });
  }

  function updateCount() {
    var el = document.getElementById('rb-diamond-count');
    if (!el) return;
    var hasMore = displayedCount < allLoadedResults.length || rbHasNextPage;
    var total = totalCount || allLoadedResults.length;
    el.textContent = 'Mostrando ' + displayedCount.toLocaleString('en-US')
      + ' de ' + total.toLocaleString('en-US')
      + ' diamantes';
  }

  function renderGrid() {
    var grid = document.getElementById('rb-diamond-grid');
    if (!grid) return;

    if (results.length === 0) {
      grid.innerHTML = '<p class="rb-empty">No se encontraron diamantes con los filtros seleccionados. Intenta ampliar los criterios.</p>';
      return;
    }

    grid.innerHTML = results.map(renderCard).join('\n');

    grid.querySelectorAll('.rb-select-diamond-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        try { selectDiamond(JSON.parse(btn.getAttribute('data-diamond'))); }
        catch (e) { showError('Error al seleccionar diamante.'); }
      });
    });

    grid.querySelectorAll('.rb-card__media--clickable').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('.rb-diamond-popup-btn')) return;
        try { openDiamondPopup(JSON.parse(el.getAttribute('data-diamond-json')), null); }
        catch (ex) { showError('Error al abrir detalle.'); }
      });
    });

    grid.querySelectorAll('.rb-diamond-popup-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        try { openDiamondPopup(JSON.parse(btn.getAttribute('data-diamond-json')), null); }
        catch (ex) { showError('Error al abrir detalle.'); }
      });
    });
  }

  function renderCard(d) {
    // price_with_markup is already in USD (applyMarkup divides cents→dollars on the worker)
    var price       = fmt$(d.price_with_markup);
    var encoded     = escAttr(JSON.stringify(d));
    var videoBadge  = d.video_360_url
      ? '<button class="rb-diamond-popup-btn rb-badge-360" data-diamond-json="' + encoded + '" title="Ver 360°" aria-label="Ver video 360°">&#9654; 360°</button>'
      : '';
    var mainLine = [d.carat + ' ct', d.color, d.clarity].filter(Boolean).join(' · ');
    var subLine  = [d.cut, d.cert_lab].filter(Boolean).join(' · ');

    return '<div class="rb-card rb-diamond-card" data-diamond-id="' + esc(d.id) + '" role="listitem">'
      + '<div class="rb-card__media rb-card__media--clickable" data-diamond-json="' + encoded + '">'
      + (d.image_url
        ? '<img src="' + esc(d.image_url) + '" alt="Diamante ' + (d.carat || '') + 'ct" loading="lazy">'
        : '<div class="rb-card__image-placeholder rb-diamond-placeholder">' + diamondSvg() + '</div>')
      + videoBadge
      + '</div>'
      + '<div class="rb-card__body">'
      + '<p class="rb-card__main-line">' + esc(mainLine) + '</p>'
      + (subLine ? '<p class="rb-card__sub-line">' + esc(subLine) + '</p>' : '')
      + '<p class="rb-card__price">' + price + '</p>'
      + '</div>'
      + '<div class="rb-card__footer">'
      + '<button class="rb-btn rb-btn--primary rb-btn--full rb-select-diamond-btn" data-diamond="' + encoded + '">SELECCIONAR</button>'
      + '</div>'
      + '</div>';
  }

  function getVideoModal() {
    var modal = document.getElementById('rb-video-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'rb-video-modal';
      modal.innerHTML =
        '<div class="rb-video-overlay"></div>'
        + '<div class="rb-video-container">'
        + '<button class="rb-video-close" aria-label="Cerrar video">✕</button>'
        + '<iframe id="rb-video-iframe" src="" width="500" height="500"'
        + ' frameborder="0" allow="autoplay; fullscreen" allowfullscreen'
        + ' title="Video 360°"></iframe>'
        + '</div>';
      document.body.appendChild(modal);

      function closeModal() {
        modal.style.display = 'none';
        document.getElementById('rb-video-iframe').src = '';
      }
      modal.querySelector('.rb-video-overlay').addEventListener('click', closeModal);
      modal.querySelector('.rb-video-close').addEventListener('click', closeModal);
    }
    return modal;
  }

  function openVideoModal(videoUrl) {
    var modal = getVideoModal();
    document.getElementById('rb-video-iframe').src = videoUrl;
    modal.style.display = 'flex';
  }

  function buildDiamondPopup() {
    if (document.getElementById('rb-diamond-popup')) return;
    var popup = document.createElement('div');
    popup.id = 'rb-diamond-popup';
    popup.innerHTML = [
      '<div class="rbp-overlay"></div>',
      '<div class="rbp-modal">',
      '  <button class="rbp-close">&#x2715;</button>',
      '  <div class="rbp-modal-scroll">',
      '    <div class="rbp-top">',
      '      <div class="rbp-video-wrap">',
      '        <iframe id="rbp-iframe" src="" frameborder="0" allowfullscreen></iframe>',
      '      </div>',
      '      <div class="rbp-info">',
      '        <div class="rbp-eyebrow">Diamante certificado</div>',
      '        <div class="rbp-title" id="rbp-title"></div>',
      '        <div class="rbp-subtitle" id="rbp-subtitle"></div>',
      '        <div class="rbp-badges" id="rbp-badges"></div>',
      '        <div class="rbp-price" id="rbp-price"></div>',
      '        <div class="rbp-actions">',
      '          <button class="rbp-btn-primary" id="rbp-select">&#x2726; Elegir este diamante</button>',
      '          <a class="rbp-btn-secondary" id="rbp-cert" href="#" target="_blank">',
      '            <svg width="11" height="11" viewBox="0 0 16 16" fill="none">',
      '              <path d="M14 10v3a1 1 0 01-1 1H3a1 1 0 01-1-1v-3M8 2v8M5 7l3 3 3-3"',
      '                    stroke="currentColor" stroke-width="1.2"/>',
      '            </svg>',
      '            Ver certificado',
      '          </a>',
      '        </div>',
      '      </div>',
      '    </div>',
      '    <div class="rbp-stats" id="rbp-stats"></div>',
      '    <div class="rbp-details" id="rbp-details"></div>',
      '    <a class="rbp-btn-secondary rbp-cert-mobile" id="rbp-cert-mobile" href="#" target="_blank" style="display:none">',
      '      <svg width="11" height="11" viewBox="0 0 16 16" fill="none">',
      '        <path d="M14 10v3a1 1 0 01-1 1H3a1 1 0 01-1-1v-3M8 2v8M5 7l3 3 3-3"',
      '              stroke="currentColor" stroke-width="1.2"/>',
      '      </svg>',
      '      Ver certificado',
      '    </a>',
      '  </div>',
      '  <button class="rbp-btn-primary rbp-mobile-select" id="rbp-mobile-select">&#x2726; Elegir este diamante</button>',
      '</div>'
    ].join('');
    document.body.appendChild(popup);
    popup.querySelector('.rbp-overlay').addEventListener('click', closeDiamondPopup);
    popup.querySelector('.rbp-close').addEventListener('click', closeDiamondPopup);
  }

  function openDiamondPopup(diamond, itemId) {
    buildDiamondPopup();

    var cert       = diamond.certificate || diamond;
    var carats     = cert.carats     || cert.carat       || '—';
    var lab        = cert.lab        || cert.cert_lab    || '';
    var certNumber = cert.certNumber || cert.cert_number || '';
    var labgrown   = isLabGrown(diamond);
    var videoSrc   = diamond.videoUrl || diamond.video || diamond.video_360_url || '';
    var pdfUrl     = cert.pdfUrl || diamond.cert_pdf_url || '';
    var price      = diamond.price_with_markup
      ? diamond.price_with_markup.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 0})
      : '—';

    console.log('Certificate completo:', JSON.stringify(cert));
    console.log('pdfUrl:', cert.pdfUrl);
    console.log('Video URL (raw):', videoSrc);

    // Ajustar dimensiones embebidas en la URL de Loupe360
    // Formato: .../video/WIDTH/HEIGHT?... → reemplazar con 400/400 (coincide con el contenedor)
    if (videoSrc && videoSrc.includes('loupe360.com')) {
      videoSrc = videoSrc.replace(/\/video\/\d+\/\d+/, '/video/400/400');
      console.log('Video URL (adjusted):', videoSrc);
    }

    document.getElementById('rbp-iframe').src = videoSrc;

    document.getElementById('rbp-title').textContent =
      carats + 'ct · ' + (cert.color || '') + ' · ' + (cert.clarity || '') + ' · ' + (cert.shape || '');

    document.getElementById('rbp-subtitle').textContent =
      (cert.cut || '') + (lab ? ' · ' + lab : '') + (labgrown ? ' · Lab-Grown' : ' · Natural');

    document.getElementById('rbp-price').textContent = '$' + price;

    var badges = [];
    if (labgrown) badges.push({text: 'Lab-Grown', style: 'burg'});
    if (diamond.eyeClean === 'Yes') badges.push({text: 'Eye Clean', style: 'outline'});
    if (!diamond.brown && !diamond.green && !diamond.milky) badges.push({text: 'No BGM', style: 'outline'});
    if (lab) badges.push({text: lab + ' Cert.', style: 'outline'});
    document.getElementById('rbp-badges').innerHTML = badges
      .map(function (b) { return '<span class="rbp-badge rbp-badge--' + b.style + '">' + esc(b.text) + '</span>'; })
      .join('');

    document.getElementById('rbp-stats').innerHTML = [
      {label: 'Quilates',      value: carats + ' ct'},
      {label: 'Color',         value: cert.color    || '—'},
      {label: 'Claridad',      value: cert.clarity  || '—'},
      {label: 'Corte',         value: cert.cut      || '—'},
      {label: 'Fluorescencia', value: cert.floInt   || 'None'}
    ].map(function (s, i) {
      return '<div class="rbp-stat ' + (i < 4 ? 'rbp-stat--border' : '') + '">'
        + '<div class="rbp-stat-label">' + esc(s.label) + '</div>'
        + '<div class="rbp-stat-value">' + esc(s.value) + '</div>'
        + '</div>';
    }).join('');

    var measures = (cert.length && cert.width && cert.depth)
      ? (cert.length + '\xd7' + cert.width + '\xd7' + cert.depth) : '—';
    document.getElementById('rbp-details').innerHTML = [
      {label: 'Polish',      value: cert.polish     || '—'},
      {label: 'Simetría',    value: cert.symmetry   || '—'},
      {label: 'Medidas',     value: measures},
      {label: 'Forma',       value: cert.fullShape  || cert.shape || '—'},
      {label: 'Certificado', value: lab + (certNumber ? ' #' + certNumber : '')},
      {label: 'Origen',      value: labgrown ? 'Lab-Grown' : 'Natural'}
    ].map(function (det) {
      return '<div class="rbp-detail-item">'
        + '<span class="rbp-detail-label">' + esc(det.label) + '</span>'
        + '<span class="rbp-detail-value">' + esc(det.value) + '</span>'
        + '</div>';
    }).join('');

    var certBtn = document.getElementById('rbp-cert');
    if (pdfUrl) {
      certBtn.href = pdfUrl;
    } else if (lab === 'GIA') {
      certBtn.href = 'https://www.gia.edu/report-check?reportno=' + certNumber;
    } else if (lab === 'IGI') {
      certBtn.href = 'https://www.igi.org/verify-your-report/?reportno=' + certNumber;
    } else {
      certBtn.href = '#';
    }
    certBtn.style.display = 'flex';
    certBtn.target = '_blank';

    var certMobile = document.getElementById('rbp-cert-mobile');
    if (certMobile) {
      certMobile.href = certBtn.href;
      certMobile.style.display = 'flex';
    }

    var selectHandler = function () {
      closeDiamondPopup();
      selectDiamond(diamond, itemId);
    };
    document.getElementById('rbp-select').onclick = selectHandler;
    document.getElementById('rbp-mobile-select').onclick = selectHandler;

    document.getElementById('rb-diamond-popup').classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeDiamondPopup() {
    var popup = document.getElementById('rb-diamond-popup');
    if (popup) {
      popup.classList.remove('open');
      document.getElementById('rbp-iframe').src = '';
      document.body.style.overflow = '';
    }
  }

  function renderPagination() {
    var wrap = document.getElementById('rb-load-more-wrap');
    if (!wrap) return;
    var showLoadMore = displayedCount < allLoadedResults.length || rbHasNextPage;
    wrap.classList.toggle('visible', showLoadMore);
  }

  // ── Select Diamond ───────────────────────────────────────────────────────────

  function selectDiamond(d) {
    var overlay = document.getElementById('rb-loading-overlay');
    if (overlay) overlay.classList.remove('rb-hidden');

    // Guardar diamante en sessionStorage — la reserva en Shopify se hace al checkout
    var diamond = {
      id:               d.id,
      carat:            d.carat,
      color:            d.color,
      clarity:          d.clarity,
      cut:              d.cut,
      cert_lab:         d.cert_lab,
      cert_number:      d.cert_number,
      price_with_markup: d.price_with_markup,
      nivoda_price:     d.nivoda_price,
      image_url:        d.image_url,
      video_360_url:    d.video_360_url,
      shape:            d.shape
    };

    sessionStorage.setItem('diamore_diamond',    JSON.stringify(diamond));
    sessionStorage.setItem('diamore_stone_type', stoneType);

    // Navegar: a review si ya hay montura, sino a página de monturas
    // settingId puede venir de URL param (entrySettingId) O de sessionStorage (flujo PDP → diamante)
    var sessionSetting = null;
    try { sessionSetting = JSON.parse(sessionStorage.getItem('diamore_setting') || 'null'); } catch (e) {}
    var resolvedSettingId = entrySettingId
      || (sessionSetting && /^\d+$/.test(sessionSetting.variantId || '') ? sessionSetting.variantId : '');

    if (resolvedSettingId) {
      window.location.href = cfg.reviewPageUrl
        + '?diamond=' + encodeURIComponent(d.id)
        + '&setting=' + resolvedSettingId;
    } else {
      var dShape = d.shape || entryShape || '';
      var destUrl = '/collections/monturas?diamond=' + encodeURIComponent(d.id);
      if (dShape) destUrl += '&shape=' + encodeURIComponent(dShape);
      window.location.href = destUrl;
    }
  }

  // ── Events ───────────────────────────────────────────────────────────────────

  function bindEvents() {
    if (_bindsDone) return;
    _bindsDone = true;

    var debouncedFetch = debounce(function () {
      filters.offset = 0;
      appendMode   = false;
      fetchDiamonds();
    }, 500);

    // Shape pills
    document.querySelectorAll('#rb-filter-shapes [data-shape]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var shape    = btn.dataset.shape;
        var shapeUp  = shape.toUpperCase();
        var idx      = filters.shapes.indexOf(shapeUp);
        if (idx > -1) {
          filters.shapes.splice(idx, 1);
          btn.classList.remove('rb-filter-btn--active');
          btn.setAttribute('aria-pressed', 'false');
        } else {
          filters.shapes.push(shapeUp);
          btn.classList.add('rb-filter-btn--active');
          btn.setAttribute('aria-pressed', 'true');
        }
        filters.offset = 0;
        appendMode   = false;
        debouncedFetch();
      });
    });

    // Stone type
    document.querySelectorAll('input[name="rb-stone-type"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) {
          stoneType = radio.value;
          sessionStorage.setItem('diamore_stone_type', stoneType);
          applyDefaultColors(stoneType);
          filters.offset = 0;
          appendMode   = false;
          debouncedFetch();
        }
      });
    });

    // Cert checkboxes
    document.querySelectorAll('.rb-cert-checkbox').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var cert = cb.value;
        var idx  = filters.cert.indexOf(cert);
        if (cb.checked && idx === -1) filters.cert.push(cert);
        else if (!cb.checked && idx > -1) filters.cert.splice(idx, 1);
        filters.offset = 0;
        appendMode   = false;
        debouncedFetch();
      });
    });

    // Carat
    var caratMin = document.getElementById('rb-filter-carat-min');
    if (caratMin) caratMin.addEventListener('input', function () {
      filters.carat_min = parseFloat(this.value) || 1.00;
      updateCaratDisplay();
      debouncedFetch();
    });
    var caratMax = document.getElementById('rb-filter-carat-max');
    if (caratMax) caratMax.addEventListener('input', function () {
      filters.carat_max = parseFloat(this.value) || 5.00;
      updateCaratDisplay();
      debouncedFetch();
    });

    // Color
    document.querySelectorAll('#rb-filter-colors [data-color]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.toggle('rb-filter-btn--active');
        btn.setAttribute('aria-pressed', btn.classList.contains('rb-filter-btn--active') ? 'true' : 'false');
        var c = btn.dataset.color;
        var i = filters.color.indexOf(c);
        if (i > -1) filters.color.splice(i, 1); else filters.color.push(c);
        debouncedFetch();
      });
    });

    // Clarity
    document.querySelectorAll('#rb-filter-clarities [data-clarity]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.toggle('rb-filter-btn--active');
        btn.setAttribute('aria-pressed', btn.classList.contains('rb-filter-btn--active') ? 'true' : 'false');
        var c = btn.dataset.clarity;
        var i = filters.clarity.indexOf(c);
        if (i > -1) filters.clarity.splice(i, 1); else filters.clarity.push(c);
        debouncedFetch();
      });
    });

    // Price
    var priceMin = document.getElementById('rb-filter-price-min');
    if (priceMin) priceMin.addEventListener('change', function () {
      var v = parseInt(this.value, 10);
      filters.price_min = isNaN(v) ? 0 : v;
      debouncedFetch();
    });
    var priceMax = document.getElementById('rb-filter-price-max');
    if (priceMax) priceMax.addEventListener('change', function () {
      filters.price_max = parseInt(this.value, 10) || 50000;
      debouncedFetch();
    });

    // Sort
    var sortEl = document.getElementById('rb-sort-select');
    if (sortEl) sortEl.addEventListener('change', function () {
      filters.sort = this.value;
      filters.offset = 0;
      appendMode   = false;
      fetchDiamonds();
    });

    // Mobile filter toggle (desktop sidebar)
    var filterToggle = document.getElementById('rb-filter-toggle');
    if (filterToggle) {
      filterToggle.addEventListener('click', function () {
        var panel  = document.querySelector('.rb-filter-panel');
        if (!panel) return;
        var isOpen = panel.classList.toggle('rb-filter-panel--open');
        filterToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
    var applyBtn = document.getElementById('rb-filter-apply');
    if (applyBtn) applyBtn.addEventListener('click', function () {
      var panel = document.querySelector('.rb-filter-panel');
      if (panel) panel.classList.remove('rb-filter-panel--open');
      var toggle = document.getElementById('rb-filter-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      filters.offset = 0;
      appendMode = false;
      fetchDiamonds();
    });

    // Mobile drawer: "Más filtros"
    var overlay = document.getElementById('rb-drawer-overlay');

    function openDrawer() {
      var panel = document.querySelector('.rb-filter-panel');
      if (panel) panel.classList.add('rb-filter-panel--drawer-open');
      if (overlay) overlay.classList.add('rb-drawer-overlay--visible');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      var panel = document.querySelector('.rb-filter-panel');
      if (panel) panel.classList.remove('rb-filter-panel--drawer-open');
      if (overlay) overlay.classList.remove('rb-drawer-overlay--visible');
      document.body.style.overflow = '';
    }

    var moreFiltersBtn = document.getElementById('rb-more-filters-btn');
    if (moreFiltersBtn) moreFiltersBtn.addEventListener('click', openDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    var drawerClose = document.getElementById('rb-drawer-close');
    if (drawerClose) drawerClose.addEventListener('click', closeDrawer);

    var drawerApply = document.getElementById('rb-drawer-apply');
    if (drawerApply) drawerApply.addEventListener('click', function () {
      closeDrawer();
      filters.offset = 0;
      appendMode   = false;
      fetchDiamonds();
    });

    var drawerReset = document.getElementById('rb-drawer-reset');
    if (drawerReset) drawerReset.addEventListener('click', function () {
      filters.color   = [];
      filters.clarity = [];
      filters.cert    = [];
      filters.carat_min = 1.00;
      filters.carat_max = 5.00;
      filters.price_min = 0;
      filters.price_max = 50000;
      document.querySelectorAll('#rb-filter-colors [data-color]').forEach(function (btn) {
        btn.classList.remove('rb-filter-btn--active');
        btn.setAttribute('aria-pressed', 'false');
      });
      document.querySelectorAll('#rb-filter-clarities [data-clarity]').forEach(function (btn) {
        btn.classList.remove('rb-filter-btn--active');
        btn.setAttribute('aria-pressed', 'false');
      });
      document.querySelectorAll('.rb-cert-checkbox').forEach(function (cb) { cb.checked = false; });
      var cMin = document.getElementById('rb-filter-carat-min');
      var cMax = document.getElementById('rb-filter-carat-max');
      if (cMin) cMin.value = '1.00';
      if (cMax) cMax.value = '5.00';
      updateCaratDisplay();
      updateMobilePriceDisplay();
      closeDrawer();
      filters.offset = 0;
      appendMode   = false;
      fetchDiamonds();
    });

    // ── Mobile filter panel ──────────────────────────────────────────────────

    // "Más filtros" mobile button opens the drawer
    var mobileMoreFiltersBtn = document.getElementById('rb-mobile-more-filters-btn');
    if (mobileMoreFiltersBtn) mobileMoreFiltersBtn.addEventListener('click', openDrawer);

    // Mobile price sliders
    var priceMinMobile = document.getElementById('rb-price-min-mobile');
    if (priceMinMobile) priceMinMobile.addEventListener('input', function () {
      var v = parseInt(this.value, 10);
      filters.price_min = isNaN(v) ? 0 : v;
      var display = document.getElementById('rb-price-min-display');
      if (display) display.textContent = filters.price_min.toLocaleString('en-US');
      // Sync desktop input
      var desktopMin = document.getElementById('rb-filter-price-min');
      if (desktopMin) desktopMin.value = filters.price_min;
      updatePriceTrack();
      filters.offset = 0; appendMode = false;
      debouncedFetch();
    });

    var priceMaxMobile = document.getElementById('rb-price-max-mobile');
    if (priceMaxMobile) priceMaxMobile.addEventListener('input', function () {
      filters.price_max = parseInt(this.value, 10) || 50000;
      var display = document.getElementById('rb-price-max-display');
      if (display) display.textContent = filters.price_max.toLocaleString('en-US');
      // Sync desktop input
      var desktopMax = document.getElementById('rb-filter-price-max');
      if (desktopMax) desktopMax.value = filters.price_max;
      updatePriceTrack();
      filters.offset = 0; appendMode = false;
      debouncedFetch();
    });

    // Mobile shape buttons
    document.querySelectorAll('.rb-shape-btn-mobile[data-shape-mobile]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var shape    = btn.dataset.shapeMobile;
        var shapeUp  = shape.toUpperCase();
        var idx      = filters.shapes.indexOf(shapeUp);
        if (idx > -1) {
          filters.shapes.splice(idx, 1);
          btn.classList.remove('rb-filter-btn--active');
          btn.setAttribute('aria-pressed', 'false');
          var desktopBtn = document.querySelector('#rb-filter-shapes [data-shape="' + shape + '"]');
          if (desktopBtn) { desktopBtn.classList.remove('rb-filter-btn--active'); desktopBtn.setAttribute('aria-pressed', 'false'); }
        } else {
          filters.shapes.push(shapeUp);
          btn.classList.add('rb-filter-btn--active');
          btn.setAttribute('aria-pressed', 'true');
          var desktopBtn = document.querySelector('#rb-filter-shapes [data-shape="' + shape + '"]');
          if (desktopBtn) { desktopBtn.classList.add('rb-filter-btn--active'); desktopBtn.setAttribute('aria-pressed', 'true'); }
        }
        filters.offset = 0; appendMode = false;
        debouncedFetch();
      });
    });

    // Stone toggle buttons
    document.querySelectorAll('.rb-stone-toggle__opt[data-type]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        stoneType = btn.dataset.type;
        sessionStorage.setItem('diamore_stone_type', stoneType);
        document.querySelectorAll('.rb-stone-toggle__opt[data-type]').forEach(function (b) {
          b.classList.toggle('rb-stone-toggle__opt--active', b.dataset.type === stoneType);
        });
        // Sync desktop radio
        var radio = document.querySelector('input[name="rb-stone-type"][value="' + stoneType + '"]');
        if (radio) radio.checked = true;
        applyDefaultColors(stoneType);
        filters.offset = 0; appendMode = false;
        debouncedFetch();
      });
    });

    // Cut filter buttons (Bug 4)
    document.querySelectorAll('#rb-filter-cuts [data-cut]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.toggle('rb-filter-btn--active');
        btn.setAttribute('aria-pressed', btn.classList.contains('rb-filter-btn--active') ? 'true' : 'false');
        var c = btn.dataset.cut;
        var i = filters.cuts.indexOf(c);
        if (i > -1) filters.cuts.splice(i, 1); else filters.cuts.push(c);
        filters.offset = 0; appendMode = false;
        debouncedFetch();
      });
    });
  }

  // ── Boot ─────────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
